import React from 'react';
import { FileText, Upload, CheckCircle } from 'lucide-react';
import { GlassCard } from './DashboardShared';

const DocumentsPanel = ({ recentDocs, navigate }) => (
  <GlassCard data-testid="documents-section">
    <div className="flex items-center gap-2 mb-4">
      <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'rgba(34,211,238,0.15)' }}>
        <FileText className="w-4 h-4 text-cyan-400" />
      </div>
      <h3 style={{ color: '#F8FAFC', fontWeight: 700, fontSize: '18px', letterSpacing: '-0.01em' }}>Sağlık Belgelerim</h3>
    </div>

    {recentDocs.length > 0 && (
      <div className="space-y-1.5 mb-4">
        {recentDocs.map(doc => (
          <div key={doc.document_id} onClick={() => navigate('/documents')}
            className="flex items-center gap-2.5 p-2.5 rounded-xl cursor-pointer transition-all hover:bg-white/[0.03]"
            style={{ border: '1px solid rgba(255,255,255,0.04)' }}
            data-testid={`dashboard-doc-${doc.document_id}`}>
            <FileText className="w-3.5 h-3.5 text-cyan-400/60 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-white/60 text-xs font-medium truncate">{doc.doc_type_label}</p>
              <p className="text-white/25 text-[9px] truncate">{doc.ai_analysis?.plain_summary?.slice(0, 40) || doc.file_name}</p>
            </div>
            {doc.user_verified && <CheckCircle className="w-3 h-3 text-emerald-400/60 shrink-0" />}
          </div>
        ))}
      </div>
    )}

    <button onClick={() => navigate('/documents')}
      className="w-full py-5 rounded-xl flex flex-col items-center gap-2 transition-all hover:scale-[1.01]"
      style={{
        background: 'linear-gradient(135deg, rgba(34,211,238,0.1), rgba(59,130,246,0.1))',
        border: '1px dashed rgba(34,211,238,0.35)',
        boxShadow: '0 0 25px rgba(34,211,238,0.1)',
      }}
      data-testid="go-to-documents">
      <Upload className="w-7 h-7 text-cyan-400" />
      <div className="text-center">
        <p className="text-cyan-300 text-sm font-bold">Sağlık Belgelerini Yükle</p>
        <p className="text-white/30 text-[10px] mt-1">Kan tahlili, MR, psikolojik test sonucu — ne kadar çok veri, o kadar doğru analiz</p>
      </div>
    </button>

    <div className="absolute bottom-0 left-0 right-0 h-[1px]" style={{ background: 'linear-gradient(90deg, transparent, rgba(34,211,238,0.3), transparent)' }} />
  </GlassCard>
);

export default DocumentsPanel;
